import Vue from 'vue'
import { INotificationService } from '../services/NotificationService'
export interface IErrorHandlerService {
  $notificationService: INotificationService
  handle(instance: any, data: any): string
}

export default class ErrorHandlerService extends Vue
  implements IErrorHandlerService {
  public $notificationService!: INotificationService

  constructor() {
    super()
  }

  public handle(instance: any, code: any, display: boolean = false): string {
    let error = ''
    code = +code
    switch (code) {
      case 1:
        error = 'NoUserFound'
        break
      case 2:
        error = 'NoRoleFoundForUser'
        break
      case 3:
        error = 'WrongUser'
        break
      case 4:
        error = 'WrongPasswordPolicy'
        break
      case 5:
        error = 'TokenExpired'
        break
      case 6:
        error = 'TokenNotFound'
        break
      case 7:
        error = 'MissingParameter'
        break
      case 8:
        error = 'PermissionDenied'
        break
      case 9:
        error = 'UsersCreation'
        break
      case 10:
        error = 'CsvRead'
        break
      case 11:
        error = 'EmptyCsv'
        break
      case 12:
        error = 'REPOSITORY_EMAIL_ALREADY_USED'
        break
      case 13:
        error = 'DATA_NOT_MATCHING_PERMISSIONS'
        break
      case 14:
        error = 'WrongAuthorizationCode'
        break
      case 15:
        error = 'InvalidUserSource'
        break
      case 16:
        error = 'UserNameNotMatchingID'
        break
      case 17:
        error = 'OrganisationStillInUse'
        break
      case 18:
        error = 'InvalidUserData'
        break
      case 19:
        error = 'UserNotInSchool'
        break
      case 20:
        error = 'NoSchoolPermission'
        break
      case 21:
        error = 'NotOrgMember'
        break
      case 22:
        error = 'NotDataSteward'
        break
      case 30:
        error = 'LDAP.Default'
        break
      case 31:
        error = 'LDAP.AlreadyExists'
        break
      case 32:
        error = 'LDAP.InvalidCredentials'
        break
      case 33:
        error = 'LDAP.SocketOpen'
        break
      case 34:
        error = 'LDAP.AccountExpired'
        break
      case 35:
        error = 'LDAP.UserNotFound'
        break
      case 36:
        error = 'LDAP.ConstraintViolationResult'
        break
      case 37:
        error = 'LDAP.InsufficientAccessRights'
        break
      case 38:
        error = 'LDAP.EmailNotFound'
        break
      case 39:
        error = 'LDAP.UserNotInOU'
        break
      case 40:
        error = 'LDAP.MultipleEmail'
        break
      case 41:
        error = 'LDAP.SecondyEmailMissing'
        break
      case 60:
        error = 'GuestAlreadyExistForThisSchool'
        break
      case 61:
        error = 'GuestDoesNotExist'
        break
      case 62:
        error = 'GuestAlreadyExist'
        break
      case 63:
        error = 'GuestNotInAzure'
        break
      case 64:
        error = 'AzureCannotExecuteAction'
        break
      case 65:
        error = 'GuestAlreadySynchronized'
        break
      default:
        error = 'Default'
        break
    }
    const message = instance.$t('ERROR.' + error).toString()
    if (display) {
      instance.$notificationService.error(message)
    }

    return message
  }
}
